import { TextLink, Typography } from 'components';
import { useLocation } from 'react-router-dom';
import { ConditionMetricCounts } from 'services/conditions/useConditionMetrics';
import { renderMetric } from 'views/Results/Conditions/ConditionMetricPill';
import styles from './ConditionMetricsBox.module.css';
import getConditionMetricsArray from './helpers/getConditionMetricsArray';

type BoxProps = {
  conditionMetric: ConditionMetricCounts;
  conditionMetricsLength: number;
  conditionMetricIndex: number;
  conditionMetrics: ConditionMetricCounts[];
};

export default function Box({
  conditionMetric,
  conditionMetricIndex,
  conditionMetricsLength,
  conditionMetrics,
}: BoxProps) {
  const { pathname } = useLocation();

  if (conditionMetricsLength > 4 && conditionMetricIndex === 3) {
    return (
      <div className={styles.box}>
        <Typography variant='body-m'>
          {`+${conditionMetricsLength - 3} more`}
        </Typography>
        <Typography variant='body-s' color='grey' className={styles.diseases}>
          {`${conditionMetrics
            .map(cm => cm.condition_display_name)
            .slice(3, 7)
            .join(', ')}...`}
        </Typography>
      </div>
    );
  }

  const conditionMetricsArray = getConditionMetricsArray(conditionMetric);

  const url = `${pathname}/conditions/metrics/${conditionMetric.condition}`;

  return (
    <div className={styles.box}>
      <Typography variant='body-m'>
        {conditionMetric.condition_display_name}
      </Typography>
      <div className={styles.metricsContainer}>
        {conditionMetricsArray.map(
          cm =>
            cm.value > 0 && (
              <div key={cm.color} className={styles.metricContainer}>
                {renderMetric(cm.value, cm.color, styles[cm.color])}
                <Typography variant='body-s'>{cm.text}</Typography>
              </div>
            ),
        )}
      </div>
      <TextLink
        label='See insights'
        to={url}
        iconNameRight={'chevronForward'}
        className={styles.insightsLink}
      />
    </div>
  );
}
